import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setUidToken, isRtl, isVoca } from 'src/helper/tool'
import lang from './lang'
import http from 'src/helper/http'
import { closeWebViewPage, getDeviceInfo, hiddenBackButton, setTabBar } from 'src/helper/webviewFun.js'
import { getlangV2, setlang } from 'src/helper/getlang'
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    userInfo: {},
    tableLangArr: {
      en: ['Level', 'Label', 'Entry Effect'],
      tr: ['Seviye', 'Etiket', 'Giriş efekti'],
      ar: ['مستوى', 'التسمية', 'تأثير الدخول'],
      ru: ['Уровень', 'Метка', 'Влияние на вход'],
      uz: ['Yuk', 'Etiq', 'Kirish efekti'],
      id: ['Level', 'Label', 'Entry Effect'],
      pt: ['Nível', 'Rótulo', 'Efeito de Entrada'],
      fa: ['Level', 'Label', 'Entry Effect']
    },
    tableWeRowList: [
      ['1-9', '/img/activity/newLevel/icon_wealth_09.png', '-'],
      ['10-19', '/img/activity/newLevel/icon_wealth_1019.png', '/img/activity/newLevel/img_entry_wealth_19.png'],
      ['20-29', '/img/activity/newLevel/icon_wealth_2029.png', '/img/activity/newLevel/img_entry_wealth_29.png'],
      ['30-39', '/img/activity/newLevel/icon_wealth_3039.png', '/img/activity/newLevel/img_entry_wealth_39.png'],
      ['40-49', '/img/activity/newLevel/icon_wealth_4049.png', '/img/activity/newLevel/img_entry_wealth_49.png'],
      ['50-59', '/img/activity/newLevel/icon_wealth_5059.png', '/img/activity/newLevel/img_entry_wealth_59.png'],
      ['60-69', '/img/activity/newLevel/icon_wealth_6069.png', '/img/activity/newLevel/img_entry_wealth_69.png'],
      ['70-79', '/img/activity/newLevel/icon_wealth_7079.png', '/img/activity/newLevel/img_entry_wealth_79.png'],
      ['80-89', '/img/activity/newLevel/icon_wealth_8089.png', '/img/activity/newLevel/img_entry_wealth_89.png'],
      ['90-99', '/img/activity/newLevel/icon_wealth_9099.png', '/img/activity/newLevel/img_entry_wealth_99.png'],
      ['100', '/img/activity/newLevel/icon_wealth_100.png', '/img/activity/newLevel/img_entry_wealth_100.png']
    ],
    entryWealthLv: [
      '/img/voca-home/wealth-lv/img_entry_wealth_19@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_29@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_39@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_49@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_59@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_69@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_79@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_89@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_99@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_100@3x.webp'
    ],
    entryWealthLvAr: [
      '/img/voca-home/wealth-lv/img_entry_wealth_19_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_29_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_39_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_49_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_59_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_69_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_79_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_89_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_99_ar@3x.webp',
      '/img/voca-home/wealth-lv/img_entry_wealth_lv_100_ar@3x.webp'
    ],
    tableChRowList: [
      ['1-9', '/img/activity/newLevel/icon_charm_9.png'],
      ['10-19', '/img/activity/newLevel/icon_charm_1019.png'],
      ['20-29', '/img/activity/newLevel/icon_charm_2029.png'],
      ['30-39', '/img/activity/newLevel/icon_charm_3039.png'],
      ['40-49', '/img/activity/newLevel/icon_charm_4049.png'],
      ['50-59', '/img/activity/newLevel/icon_charm_5059.png'],
      ['60-69', '/img/activity/newLevel/icon_charm_6069.png'],
      ['70-79', '/img/activity/newLevel/icon_charm_7079.png'],
      ['80-89', '/img/activity/newLevel/icon_charm_8089.png'],
      ['90-99', '/img/activity/newLevel/icon_charm_9099.png'],
      ['100', '/img/activity/newLevel/icon_charm_100.png']
    ],
    tableLangCh: {
      en: ['Level', 'Label'],
      tr: ['Level', 'Label'],
      ar: ['Level', 'Label']
    },
    tabIndex: 1,
    moveStartX: 0,
    mySwiper:null,
    moveStartY:0,
    stmey:'',
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const uid = await setUidToken(this.props.location.query)
    language = await getlangV2(language, lang)
    this.setState({
      lang: setlang(language, lang),
      language: language || "en",
      uid
    })
    try {
      let res = await getDeviceInfo()
      this.setState({stmey:res.res.os})
    } catch (error) { }
    let _that = this
    const mySwiper = new Swiper('.swiper-container', {
      on: {
        slideChange: function (e) {
          if (e.activeIndex == 0) {
            this.allowSlideNext = true
            this.allowSlidePrev = false
          }else if(e.activeIndex == 1){
            this.allowSlideNext = false
            this.allowSlidePrev = true
          }
          _that.setState({tabIndex:e.activeIndex+1})
        },
      },
      
    })
    mySwiper.allowSlidePrev = false
      this.mySwiper = mySwiper
    this.setState({mySwiper})
    this.getUserInfo(uid)
  }
  mySwiper = null
  getUserInfo = async (uid) => {
    let res = await http.post('/web/MyAccountInfo', { uid: uid || 106879 })
    if (res.code == 0) {
      this.setState({ userInfo: res.res })
    }
    hiddenBackButton('0')
    setTabBar('1')
  }

  getLvBg = (e = 0) => {
    let { tabIndex, userInfo } = this.state
    e = tabIndex == 1 ? userInfo.wealthLv : userInfo.charmLv
    let srt = ''
    if (e == 0) {
      srt = '0'
    } else if (e > 0 && e <= 9) {
      srt = '09'
    } else if (e > 9 && e <= 19) {
      srt = '1019'
    } else if (e > 19 && e <= 29) {
      srt = '2029'
    } else if (e > 29 && e <= 39) {
      srt = '3039'
    } else if (e > 39 && e <= 49) {
      srt = '4049'
    } else if (e > 49 && e <= 59) {
      srt = '5059'
    } else if (e > 59 && e <= 69) {
      srt = '6069'
    } else if (e > 69 && e <= 79) {
      srt = '7079'
    } else if (e > 79 && e <= 89) {
      srt = '8089'
    } else if (e > 89 && e <= 99) {
      srt = '9099'
    } else if (e == 100) {
      srt = '100'
    } else {
      srt = '0'
    }
    return srt
  }

  handleSetTabCard = (e) => {
    this.setState({ tabIndex: e })
    console.log(this.mySwiper,this.mySwiper.slideTo)
    this.mySwiper.slideTo(e-1, 600, false);
  }

  getPrWith = () => {
    let { tabIndex, userInfo } = this.state
    //6.22
    let str = ''
    if (tabIndex == 1) {
      process = (userInfo.wealth * 100000) / (userInfo.wealth + userInfo.wealthNext)
      str = parseInt(process) / 1000 + '%'
    } else if (tabIndex == 2) {
      process = (userInfo.charm * 100000) / (userInfo.charm + userInfo.charmNext)
      str = parseInt(process) / 1000 + '%'
    }
    return str
  }

  timeId = null

  render() {
    let { stmey, language, lang, userInfo, tableLangArr, tableWeRowList, entryWealthLv, entryWealthLvAr, tabIndex, tableChRowList } = this.state
    return (
      <div
        className={`newLevel ${tabIndex == 1 ? '' : ''} ${isRtl(language) ? 'arlang' : ''}`}
      >  
      <div  className={`newlevel-nav  ${tabIndex == 1  ? 'wealth-nav-bg' : 'charm-nav-bg'}`}>
          <div style={{width:'100%',height:'0.88rem'}}></div>
        <div className={`close-fied-root `}  >
        <img
              className="close-icon-webview"
              onClick={() => closeWebViewPage()}
              src="/img/activity/newLevel/close_icon.png"
              style={{
                [isRtl(language) ? 'right' : 'left']: '0.32rem',
                transform: `${isRtl(language) ? 'rotate(180deg)' : ''}`
              }}
            ></img>
            <div className="select-tab">
              <div
                className={`in-the-tab`}
                onClick={() => this.handleSetTabCard(1)}
              >
                <div>{lang.wealth}</div>
                {tabIndex == 1 && <div className="timei"></div>}
              </div>
              <div
                className={`${tabIndex == 2 ? 'in-the-tab' : 'on-the-tab'}`}
                onClick={() => this.handleSetTabCard(2)}
              >
                <div>{lang.charm}</div>
                {tabIndex == 2 && <div className="timei"></div>}
              </div>
            </div>
        </div>
        </div>
        <img src='/img/activity/newLevel/ios_nav.png' style={{width:'1px',height:'1px',display:'contents'}}></img>
        <div className='swiper-container'>
        <div className='swiper-wrapper'>
        <div className={`intheWealth  swiper-slide`} >
        <div className={`topbanner in-the-wealth`}>
          <div className="tab-and-close">
         
            <div className={'user-info-root'}>
              <img
                className="user-atv"
                src={userInfo.avatarurl}
                style={{ [isRtl(language) ? 'right' : 'left']: '0.32rem' }}
              ></img>
              <div className="user-info" style={{ [isRtl(language) ? 'marginRight' : 'marginLeft']: '1.92rem' }}>
                <div className="top">
                  <div className="name">{userInfo.nickname}</div>
                  <div className="web-lv">
                    <img
                      className="lv-img"
                      src={`/img/activity/newLevel/wealthLv/icon_wealth_${this.getLvBg()}@3x.png`}
                    ></img>
                    <div className="lv-num" style={{right:`${userInfo.wealthLv&&userInfo.wealthLv >9?'0.14rem':'0.21rem'}`}}>{userInfo.wealthLv}</div>
                  </div>
                </div>
                {language == 'en' &&<div className="btm">
                  Need <span>{tabIndex == 1 ? userInfo.wealthNext : userInfo.charmNext}</span> Exp to Lv.
                  {tabIndex == 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                </div>}
                {language == 'tr' &&<div className="btm">
                  Level {tabIndex == 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1} için ihtiyaç <span>{tabIndex == 1 ? userInfo.wealthNext : userInfo.charmNext}</span>
                </div>}
                {language == 'ar' &&<div className="btm">
                  تحتاج إلى <span>{tabIndex == 1 ? userInfo.wealthNext : userInfo.charmNext}</span> لوصل الى LV.{tabIndex == 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                </div>}
                {
                  language === 'ru' && (<div className="btm">
                    Нужно <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> опыта для  {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}-го уровня.
                  </div>)
                }
                {
                  language === 'uz' && (<div className="btm">
                    Lv.{tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1} uchun
                    <span> {tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> ta tajriba kerak.
                  </div>)
                }
                {
                  language === 'id' && (<div className="btm">
                    Butuh <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> exp ke lv.
                    {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
                {
                  language === 'pt' && (<div className="btm">
                    Precisa de <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> exp para nível 
                    {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
                {
                  language === 'fa' && (<div className="btm">
                    باید <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> اعتبار داشته باشد
                    برای مرحله {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
                {
                  language === 'ur' && (<div className="btm">
                    ہم نیازمند <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> امتیاز برای مرحلہ 
                    {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
              </div>
              <div className="process-root">
                <div className="lelve-info">
                  <div className="leve-num">Lv{tabIndex == 1 ? userInfo.wealthLv : userInfo.charmLv}</div>
                  <div className="leve-experience">{this.getPrWith()}</div>
                </div>
                <div className="leve-process">
                  <div className="inset-process" style={{ width: this.getPrWith() }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'privileges-root'}>
          <img
            className="right-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/right_iocn.png`}
          ></img>
          <div className="text-root">{lang.Previleges}</div>

          <img
            className="left-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/left-icon.png`}
          ></img>
        </div>
    
          <div className="table-root-newLevel">
            <div className="newLevel-table">
              <table>
                <thead style={{ height: '0.88rem' }}>
                  <tr style={{ height: '0.88rem' }}>
                    <td style={{ height: '0.88rem' }}>{tableLangArr && tableLangArr[language] && tableLangArr[language][0]}</td>
                    <td style={{ height: '0.88rem' }}>{tableLangArr && tableLangArr[language] && tableLangArr[language][1]}</td>
                    <td style={{ height: '0.88rem', [language !== 'ar' ? 'borderRight' : 'borderLeft']: '0.01rem solid #f6d78e' }}>
                      {tableLangArr && tableLangArr[language] && tableLangArr[language][2]}
                    </td>
                  </tr>
                </thead>
                {tableWeRowList.length > 0 &&
                  tableWeRowList.map((item, index) => {
                    return (
                      <tbody key={index} >
                        <tr >
                          <td style={{ width: '1.14rem', height: '0.96rem' }}>{item[0]}</td>
                          <td style={{ width: '1.88rem', height: '0.96rem' }}>
                            <img style={{ width: '1.2rem', height: '0.48rem' }} src={item[1]} />
                          </td>
                          <td style={{ width: '3rem', height: '0.96rem' }}>
                            {index == 0 && <div>{'-'}</div>}
                            {index !== 0 && <img src={isVoca() ? language === 'ar' ? entryWealthLvAr[index - 1] : entryWealthLv[index - 1] : item[2]} style={{ width: '3rem', height: '0.72rem' }} />}
                          </td>
                        </tr>
                      </tbody>
                    )
                  })}
              </table>
            </div>
          </div>
        <div className={'privileges-root'}>
          <img
            className="right-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/right_iocn.png`}
          ></img>
          <div className="text-root">{lang.upgrade}</div>

          <img
            className="left-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/left-icon.png`}
          ></img>
        </div>
        <div className="to-app-up">
          <div className="send-gift-root">
            <img
              className="root-icon"
              src={`/img/activity/newLevel/send_gift_icon.png`}
            ></img>
            <div className="tip-text">
              <div className={`title`}>{lang.Gifts}</div>
              <div className={`tips`}>{lang.coins}</div>
            </div>
          </div>
          <div className="send-gift-root">
            <img
              className="root-icon"
              src={`/img/activity/newLevel/buy_vip_icon.png`}
            ></img>
            <div className="tip-text">
              <div className={`title`}>{lang.Aristocracy}</div>
              <div className={`tips`}>{lang.coins}</div>
            </div>
          </div>
          <div className="send-gift-root">
            <img
              className="root-icon"
              src={`/img/activity/newLevel/buy_car_icon.png`}
            ></img>
            <div className="tip-text">
              <div className={`title`}>{lang.Mounts}</div>
              <div className={`tips`}>{lang.coins}</div>
            </div>
          </div>
        </div>
        </div>
        <div  className={`intheCharm swiper-slide`} >
        <div className={`topbanner in-the-charm`}>
          <div className="tab-and-close">
          {false &&<img
              className="close-icon-webview"
              onClick={() => closeWebViewPage()}
              src="/img/activity/newLevel/close_icon.png"
              style={{
                [isRtl(language) ? 'right' : 'left']: '0.32rem',
                transform: `${isRtl(language) ? 'rotate(180deg)' : ''}`
              }}
            ></img>}
            {false &&<div className="select-tab">
              <div
                className={`${tabIndex == 1 ? 'in-the-tab' : 'on-the-tab'}`}
                onClick={() => this.handleSetTabCard(1)}
              >
                <div>{lang.wealth}</div>
                {tabIndex == 1 && <div className="timei"></div>}
              </div>
              <div
                className={`${tabIndex == 2 ? 'in-the-tab' : 'on-the-tab'}`}
                onClick={() => this.handleSetTabCard(2)}
              >
                <div>{lang.charm}</div>
                {tabIndex == 2 && <div className="timei"></div>}
              </div>
            </div>}
            <div className={'user-info-rootch'}>
              <img
                className="user-atv"
                src={userInfo.avatarurl}
                style={{ [isRtl(language) ? 'right' : 'left']: '0.32rem' }}
              ></img>
              <div className="user-info" style={{ [isRtl(language) ? 'marginRight' : 'marginLeft']: '1.92rem' }}>
                <div className="top">
                  <div className="name">{userInfo.nickname}</div>
                  <div className="web-lv">
                    <img
                      className="lv-img"
                      src={`/img/activity/newLevel/charm/icon_charm_${this.getLvBg()}@3x.png`}
                    ></img>
                    <div className="lv-num" style={{right:`${userInfo.wealthLv&&userInfo.wealthLv >9?'0.14rem':'0.21rem'}`}}>{tabIndex == 1 ? userInfo.wealthLv : userInfo.charmLv}</div>
                  </div>
                </div>
                {language == 'en' &&<div className="btm">
                  Need <span>{tabIndex == 1 ? userInfo.wealthNext : userInfo.charmNext}</span> Exp to Lv.
                  {tabIndex == 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                </div>}
                {language == 'tr' &&<div className="btm">
                  Level {tabIndex == 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1} için ihtiyaç <span>{tabIndex == 1 ? userInfo.wealthNext : userInfo.charmNext}</span>
                </div>}
                {language == 'ar' &&<div className="btm">
                  تحتاج إلى <span>{tabIndex == 1 ? userInfo.wealthNext : userInfo.charmNext}</span> لوصل الى LV.{tabIndex == 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                </div>}
                {
                  language === 'ru' && (<div className="btm">
                    Нужно <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> опыта для  {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}-го уровня.
                  </div>)
                }
                {
                  language === 'uz' && (<div className="btm">
                    Lv.{tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1} uchun
                    <span> {tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> ta tajriba kerak.
                  </div>)
                }
                {
                  language === 'id' && (<div className="btm">
                    Butuh <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> exp ke lv.
                    {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
                {
                  language === 'pt' && (<div className="btm">
                    Precisa de <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> exp para nível 
                    {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
                {
                  language === 'fa' && (<div className="btm">
                    باید <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> اعتبار داشته باشد
                    برای مرحله {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
                {
                  language === 'ur' && (<div className="btm">
                    ہم نیازمند <span>{tabIndex === 1 ? userInfo.wealthNext : userInfo.charmNext}</span> امتیاز برای مرحلہ 
                    {tabIndex === 1 ? userInfo.wealthLv + 1 : userInfo.charmLv + 1}
                  </div>)
                }
              </div>
              <div className="process-root">
                <div className="lelve-info">
                  <div className="leve-num">Lv{tabIndex == 1 ? userInfo.wealthLv : userInfo.charmLv}</div>
                  <div className="leve-experience">{this.getPrWith()}</div>
                </div>
                <div className="leve-process">
                  <div className="inset-process" style={{ width: this.getPrWith() }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'privileges-rootch'}>
          <img
            className="right-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/chright_iocn.png`}
          ></img>
          <div className="text-root">{lang.Previleges}</div>

          <img
            className="left-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/chleft-icon.png`}
          ></img>
        </div>
          <div className="newLevel-table-rootch">
            <div className="chrwb-table">
              <table>
                <thead style={{ height: '0.88rem' }}>
                  <tr style={{ height: '0.88rem' }}>
                    <td style={{ height: '0.88rem', [language !== 'ar' ? 'borderRight' : 'borderLeft']: '0.01rem solid #fa91bb' }}>
                      {tableLangArr && tableLangArr[language] && tableLangArr[language][0]}
                    </td>
                    <td style={{ height: '0.88rem' }}>{tableLangArr && tableLangArr[language] && tableLangArr[language][1]}</td>
                  </tr>
                </thead>
                {tableChRowList.length > 0 &&
                  tableChRowList.map((item, index) => {
                    return (
                      <tbody key={index} style={{ height: '0.96rem' }}>
                        <tr style={{ height: '0.96rem' }}>
                          <td style={{ height: '0.96rem', [language !== 'ar' ? 'borderRight' : 'borderLeft']: '0.01rem solid #fa91bb' }}>
                            {item[0]}
                          </td>
                          <td style={{ height: '0.96rem' }}>
                            <img style={{ width: '1.2rem', height: '0.48rem' }} src={item[1]} />
                          </td>
                        </tr>
                      </tbody>
                    )
                  })}
              </table>
            </div>
          </div>
        <div className={'privileges-rootch'}>
          <img
            className="right-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/chright_iocn.png`}
          ></img>
          <div className="text-root">{lang.upgrade}</div>

          <img
            className="left-icon"
            style={{ transform: `${isRtl(language) ? 'rotate(180deg)' : ''}` }}
            src={`/img/activity/newLevel/chleft-icon.png`}
          ></img>
        </div>
        <div className="to-app-up">
          <div className="send-gift-root">
            <img
              className="root-icon"
              src={`/img/activity/newLevel/chsend_gift_icon.png`}
            ></img>
            <div className="tip-text">
              <div className={`titlech`}>{lang.Gifts}</div>
              <div className={`tipsch`}>{lang.coins}</div>
            </div>
          </div>
          <div className="send-gift-root">
            <img
              className="root-icon"
              src={`/img/activity/newLevel/chbuy_vip_icon.png`}
            ></img>
            <div className="tip-text">
              <div className={`titlech`}>{lang.Aristocracy}</div>
              <div className={`tipsch`}>{lang.coins}</div>
            </div>
          </div>
          <div className="send-gift-root">
            <img
              className="root-icon"
              src={`/img/activity/newLevel/chbuy_car_icon.png`}
            ></img>
            <div className="tip-text">
              <div className={`titlech`}>{lang.Mounts}</div>
              <div className={`tipsch`}>{lang.coins}</div>
            </div>
          </div>
        </div>
        </div>
        </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/newLevel/index.js